function saveUTMParams() {
    const params = new URLSearchParams(window.location.search);

    const utms = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    utms.forEach(key => {
        const value = params.get(key);
        if (value && !getCookie(key)) {
            setCookie(key, value, 30);
        }
    });
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}


document.addEventListener("DOMContentLoaded", function() {

    function setLanguage() {
        const currentPath = window.location.pathname;

        const languages = {
            en: '/en',
            fr: '/fr',
            de: '/de',
            es: '/es',
        };

        const defaultLang = 'it';
        const cookieName = 'preferred_lang';

        function hasLanguagePrefix(path) {
            return Object.values(languages).some(prefix =>
                path === prefix || path.startsWith(prefix + '/')
            );
        }

        const preferredLang = getCookie(cookieName);

        if (!hasLanguagePrefix(currentPath)) {

            let targetLang = preferredLang;

            if (!targetLang) {
                targetLang = (navigator.language || defaultLang).split('-')[0];
            }

            if (!languages[targetLang]) {
                targetLang = defaultLang;
            }

            if (targetLang !== defaultLang) {
                const newPath = currentPath === "/" ? "" : currentPath;
                const newUrl = window.location.origin + languages[targetLang] + newPath + window.location.search + window.location.hash;

                window.location.replace(newUrl);
            }
        }
    }

    document.querySelectorAll('[data-value]').forEach(el => {
        el.addEventListener('click', function () {
            const lang = this.dataset.value;
            setCookie('preferred_lang', lang, 365);
        });
    });

    setLanguage();

    saveUTMParams();

    function calcMenuH() {
        const menu = document.querySelector("header");
        let menuh = 0;
        if (menu != null) {
            menuh = menu.offsetHeight;
        }
        return `${menuh}px`;
    }
    
    function calcAnnouncementH() {
        const announcement = document.querySelector("#announcement-bar-custom");
        let announcementH = 0;
        if (announcement != null) {
            announcementH = announcement.offsetHeight;
        }
        return `${announcementH}px`;
    }

    function calcMarqueeH() {
        const marquee = document.querySelector("#marquee-pugliamare");
        let marqueeH = 0;
        if (marquee != null) {
            marqueeH = marquee.offsetHeight;
        }
        return `${marqueeH}px`;
    }
    
    document.documentElement.style.setProperty('--menuh', calcMenuH());
    document.documentElement.style.setProperty('--announcementh', calcAnnouncementH());
    document.documentElement.style.setProperty('--marqueeh', calcMarqueeH());
    
    console.log("Pugliamare works, " + document.documentElement.style.getPropertyValue('--menuh'));
    
    function setPreferredLang(langCode) {
        document.cookie = `preferred_lang=${langCode}; path=/; max-age=${60*60*24*30}`; // 30 giorni
    }

    const url = [
        '/collections/',
        '/collections',
        '/products/',
        '/products',
        '/products/pickup',
        '/products/pickup/'
    ];

    url.forEach(path => {
        if (window.location.pathname === path) {
            window.location = '/';
        }
    });

    const header = document.querySelector("sticky-header");
    const logo = document.querySelector("header__heading-logo-wrapper img");

    function handleHeader() {
        const isMobile = window.innerWidth <= 576;
        const headerHeight = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        );
        const marqueeHeight = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--marqueeh')
        );

        const isTop = window.scrollY < headerHeight + marqueeHeight;

        if (isMobile && isTop && window.location.pathname === '/') {
            header.classList.add("header-transparent");
        } else {
            header.classList.remove("header-transparent");
        }
    }

    handleHeader();

    window.addEventListener("scroll", handleHeader);

    window.addEventListener("resize", handleHeader);

});

const sendAsyncForm = async (formData, formId, url='https://api.vespaescape.com/shopify/forms.php') => {
    try {
        const utms = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

        utms.forEach(key => {
            const value = getCookie(key) || `No ${key} detected for this order`;
            
            if (!formData.has(key)) {
                formData.append(key, value);
            }
        });

        formData.append('lang', currentLang);
        const infoContainer = document.createElement('div');
        infoContainer.innerHTML = waitForm;
        new Swal({
            html: infoContainer,
            icon: "info",
            customClass: {
                confirmButton: 'customBtn bgColorPrimary500 hoverBgColorPrimary400 colorWhite'
            }
        });
        const response = await fetch(`${url}`,{ method: "POST", body: formData});
        if (response.status === 200) {
            const { message } = await response.json();
            Swal.close();
            const successContainer = document.createElement('div');
            successContainer.innerHTML = successForm;
            successContainer.innerHTML += message;
            new Swal({
                html: successContainer,
                icon: "success",
                customClass: {
                    confirmButton: 'customBtn bgColorPrimary500 hoverBgColorPrimary400 colorWhite'
                }
            });
            formId.reset();
        }
        if (response.status === 400) {
            const { message } = await response.json();
            Swal.close();
            const errorContainer = document.createElement('div');
            errorContainer.innerHTML = errorForm;
            errorContainer.innerHTML += message;
            new Swal({
                html: errorContainer,
                icon: "error",
                customClass: {
                    confirmButton: 'customBtn bgColorPrimary500 hoverBgColorPrimary400 colorWhite'
                }
            });
        }
    } catch (error) {
        console.log(error);
    }
};

